import { render, staticRenderFns } from "./announcementModal.vue?vue&type=template&id=42f5dc9e"
import script from "./announcementModal.vue?vue&type=script&lang=js"
export * from "./announcementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports